import { FC, ReactNode } from "react";
import uploadCloud from "static/images/uploadCloud.svg";
import { FileIcon } from "components/design/FileIcon";

export const DragNDropArea: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="t-absolute t-z-10 t-flex  t-flex-col t-items-center t-justify-center t-gap-3 t-border t-border-dashed t-border-neutral-70 t-bg-[#f3f3f580] t-h-full t-w-full">
      <img src={uploadCloud} alt="upload" className="t-animate-drag-and-drop" />
      <span className="t-flex t-items-center t-text-text-black">
        <span>Drop files to upload them to:</span>
        <FileIcon fileType="FOLDER" className="t-ml-2 t-mr-1" />
        {children}
      </span>
    </div>
  );
};
